import AppShell from "@/components/tuw/AppShell"

// A shared placeholder for customer surfaces whose real screen lands in a later
// Atrium item (Profile, Team, Rewards, Billing, Pricing Calculator,
// Notifications). One page, reused by all six stub routes — it keeps the nav
// navigable and honest (the item highlights, the chrome renders) until the real
// screen replaces the stub. `title` doubles as the nav-highlight key, so it must
// match the sidebar item's `key`.
export default function ComingSoon({ title = "Coming soon" }) {
  return (
    <AppShell active={title} crumb={[title]}>
      <div className="grid h-full place-items-center px-6 py-20 text-center">
        <div className="max-w-md">
          <h1 className="font-display text-[22px] font-bold tracking-[-0.3px] text-foreground">{title}</h1>
          <p className="mt-2 text-[13.5px] text-ink-3">This screen is coming soon.</p>
        </div>
      </div>
    </AppShell>
  )
}
